<div class="sidebar-container" *ngIf="user">
  <div class="sidebar user-select-none">
    <div class="sidebar-items">
      <div class="sidebar-nav sidebar-nav-top">
        <!-- Insights logo -->
        <div class="sidebar-logo-item">
          <a class="sidebar-logo__icon"
             [ngClass]="{ 'sidebar-products-disabled': !productURLsLoaded }"
             [routerLink]=""
             [matMenuTriggerFor]="productlinks"
             #menuTrigger="matMenuTrigger">
            <img src="../assets/img/optimize-logo.svg" alt="Optimize" />
          </a>
          <mat-menu #productlinks class="sidebar-item-toggle__content sidebar-item-toggle__products" xPosition="after" [hasBackdrop]="true">
            <div click-stop-propagation class="p-15">
              <div class="sidebar-item-toggle__products-lable pb-12 pl-10 c-blue bold">Switch To</div>

              <div class="pl-10">
                <!-- Link to Spend -->
                <div *ngFor="let product of productDisplayList" class="d-flex align-items-center pt-12 justify-content-between">
                  <div class="d-flex align-items-center">
                    <img class="h-40" [src]="product.logoUrl" alt="{{ product.name }}" />
                  </div>
                  <a href="{{ product.redirectUrl }}" target="_blank" class="sidebar-item-toggle__products-link" (click)="menuTrigger.closeMenu()">
                    <span class="pr-5">Opens in New Tab</span>
                    <i class="fa fa-external-link" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </mat-menu>
        </div>

        <!-- Top buttons - wrapped in a div, because separator is controlled using first/last child selectors -->
        <div class="sidebar-items-wrapper">
          <div class="sidebar-item" #sidebarItem>
            <ng-container *ngTemplateOutlet="
                sidebarMenuLink;
                context: {
                  icon: 'far fa-home-alt',
                  title: 'Home',
                  url: '/home'
                }
              "></ng-container>
          </div>

          <div *ngIf="!businessUser" class="sidebar-item" #sidebarItem>
            <a class="sidebar-item__button insights-library-btn"
               [routerLink]=""
               (click)="openInsightsLibrary.emit()"
               [class.active]="insightsLibraryVisible">
              <div class="sidebar-item__icon mb-2">
                <i class="fas fa-analytics"></i>
              </div>
              <span class="sidebar-item__text">Library</span>
            </a>
          </div>

          <div *ngIf="!businessUser" class="sidebar-item" #sidebarItem>
            <ng-container *ngTemplateOutlet="
                sidebarMenuLink;
                context: {
                  icon: 'fas fa-table',
                  title: 'Visuals',
                  url: '/visuals'
                }
              "></ng-container>
          </div>

          <div *ngIf="!businessUser" class="sidebar-item" #sidebarItem>
            <ng-container *ngTemplateOutlet="
                sidebarMenuLink;
                context: {
                  icon: 'fas fa-th-large',
                  title: 'Dashboards',
                  url: '/dashboards'
                }
              "></ng-container>
          </div>

          <div *ngIf="!businessUser && schedulerEnabled" class="sidebar-item" #sidebarItem>
            <ng-container *ngTemplateOutlet="
                sidebarMenuLink;
                context: {
                  icon: 'fas fa-calendar-check',
                  title: 'Scheduler',
                  url: '/scheduler'
                }
              "></ng-container>
          </div>

          <div *ngIf="!businessUser && features?.general?.enterpriseReporting" class="sidebar-item" #sidebarItem>
            <ng-container *ngTemplateOutlet="
                sidebarMenuLink;
                context: {
                  icon: 'fas fa-user-chart',
                  title: 'Publisher',
                  url: '/publisher'
                }
              "></ng-container>
          </div>

          <div *ngIf="adminOrSupport" class="sidebar-item" #sidebarItem>
            <ng-container *ngTemplateOutlet="
                sidebarMenuLink;
                context: {
                  icon: 'far fa-cog',
                  title: 'Admin',
                  url: '/admin'
                }
              "></ng-container>
          </div>
        </div>
      </div>

      <!-- Bottom buttons, e.g. logout -->
      <div class="sidebar-nav sidebar-nav-bottom">
        <div *ngIf="!businessUser" class="sidebar-item sidebar-item-toggle force-top-separator" [class.disabled]="notificationPanelDisabled" #sidebarItem>
          <a class="sidebar-item__button"
             [routerLink]=""
             [matMenuTriggerFor]="notificationMenu"
             #notifMenuTrigger="matMenuTrigger"
             (menuOpened)="notificationMenuOpened = notifMenuTrigger.menuOpen"
             (menuClosed)="notificationMenuOpened = notifMenuTrigger.menuOpen"
             [class.active]="notificationMenuOpened">
            <div class="sidebar-item__icon">
              <i [class.fas]="notificationMenuOpened" [class.far]="!notificationMenuOpened" class="fa-bell-on"></i>
            </div>
            <span class="sidebar-item__text">Notifications</span>
          </a>
          <mat-menu #notificationMenu class="sidebar-item-toggle__content sidebar-item-toggle__notification" xPosition="after" [hasBackdrop]="true">
            <div class="bgc-blue c-white d-flex align-items-center justify-content-between h-40 px-15 br-t4">
              <div>
                <i class="far fa-bell-on mr-8"></i>
                <span class="fs-18">Notifications</span>
              </div>
              <div>
                <a class="pointer" [routerLink]="" (click)="manageProfile(2)">
                  <span class="fs-14 mr-4 underline">Manage</span>
                  <i class="fal fa-user-cog"></i>
                </a>
              </div>
            </div>
            <div class="px-15 py-15 br-b4">
              <app-notification-menu [disabled]="notificationPanelDisabled"
                                     [notificationSettings]="settings.notificationSettings"
                                     [menuTrigger]="notifMenuTrigger"></app-notification-menu>
            </div>
          </mat-menu>
        </div>
        <div class="sidebar-item sidebar-item-toggle force-top-separator" *ngIf="supportLinks?.length" #sidebarItem>
          <a class="sidebar-item__button"
             [routerLink]=""
             [matMenuTriggerFor]="supportMenu"
             #menuTrigger="matMenuTrigger"
             (menuOpened)="supportMenuOpened = menuTrigger.menuOpen"
             (menuClosed)="supportMenuOpened = menuTrigger.menuOpen"
             [class.active]="supportMenuOpened">
            @let showIcon = etlNotificationSettings() && etlNotificationSettings().spendETLEnabled && showDataHealth;
            <div class="sidebar-item__icon pin"
                 [ngClass]="{
                  warning: showIcon && etlNotificationSettings().etlStatus === 2,
                  alert:   showIcon && etlNotificationSettings().etlStatus === 1
                }">
              <i class="far fa-life-ring"></i>
            </div>
            <span class="sidebar-item__text">Support</span>
          </a>
          <mat-menu #supportMenu class="sidebar-item-toggle__content sidebar-item-toggle__support" xPosition="after" [hasBackdrop]="true">
            <div class="bgc-blue c-white d-flex align-items-center justify-content-between h-40 px-15 br-t4">
              <div>
                <i class="far fa-life-ring mr-8"></i>
                <span class="fs-18">Support</span>
              </div>
            </div>
            <div class="px-15 py-15 br-b4">
              <ng-container *ngFor="let link of supportLinks">
                <div *ngIf="link.title !== 'Data Health Status'"
                     class="support-link"
                     [class.support-link__button]="link.display === 'button'"
                     [class.support-link__has-description]="!!link.description">
                  <div class="support-link__left text-ellipsis">
                    <div class="support-link__title" [title]="link.title">
                      <a *ngIf="link.display === 'link'" class="support-link__a c-blue" [href]="link.url" [target]="link.target">
                        <span class="fs-16 bold">{{ link.title }}</span>
                        <i *ngIf="link.icon" class="{{ link.icon }} i-16 ml-6"></i>
                      </a>
                      <span *ngIf="link.display === 'button'" class="support-link__a c-grey-5">
                        <span class="fs-16 bold">{{ link.title }}</span>
                        <i *ngIf="link.icon" class="{{ link.icon }} i-16 ml-6"></i>
                      </span>
                      <a *ngIf="link.display === 'dialog'" class="support-link__a c-blue" [routerLink]="" (click)="showDialog(link.title)">
                        <span class="fs-16 bold">{{ link.title }}</span>
                        <i *ngIf="link.icon" class="{{ link.icon }} i-16 ml-6"></i>
                      </a>
                    </div>
                    <div *ngIf="link.description" class="support-link__description fs-12 text-ellipsis pr-8">
                      {{ link.description }}
                    </div>
                  </div>
                  <div class="support-link__right" *ngIf="link.display === 'button'">
                    <button trgButton color="primary" class="min-h-32 lh-32 min-w-90">
                      <span class="fs-16">{{ link.title }}</span>
                    </button>
                  </div>
                </div>

                <div *ngIf="link.title === 'Data Health Status'"
                     [hidden]="!showDataHealth"
                     class="support-link"
                     [class.support-link__button]="link.display === 'button'"
                     [class.support-link__has-description]="!!link.description">
                  <div class="support-link__left text-ellipsis">
                    <div class="support-link__title" [title]="link.title">
                      <a *ngIf="link.display === 'link'" class="support-link__a c-blue" [href]="link.url" [target]="link.target">
                        <span class="fs-16 bold">{{ link.title }}</span>
                        <i *ngIf="link.icon" class="{{ link.icon }} i-16 ml-6"></i>
                      </a>
                      <span *ngIf="link.display === 'button'" class="support-link__a c-grey-5">
                        <span class="fs-16 bold">{{ link.title }}</span>
                        <i *ngIf="link.icon" class="{{ link.icon }} i-16 ml-6"></i>
                      </span>
                      <a *ngIf="link.display === 'dialog'"
                         class="support-link__a c-blue disabled"
                         [routerLink]=""
                         [hidden]="showDataHealth"
                         (click)="showDialog(link.title)">
                        <span class="fs-16 bold">{{ link.title }}</span>
                        <i *ngIf="link.icon" class="{{ link.icon }} i-16 ml-6"></i>
                      </a>
                      <a *ngIf="link.display === 'dialog'"
                         class="support-link__a c-blue"
                         [routerLink]=""
                         [hidden]="!showDataHealth"
                         (click)="showDialog(link.title)">
                        <span class="fs-16 bold">{{ link.title }}</span>
                        <i *ngIf="link.icon" class="{{ link.icon }} i-16 ml-6"></i>
                      </a>
                    </div>
                    <div *ngIf="link.description" class="support-link__description fs-12 text-ellipsis pr-8">
                      {{ link.description }}
                    </div>
                  </div>
                  <div class="support-link__right" *ngIf="link.display === 'button'">
                    <button trgButton color="primary" class="min-h-32 lh-32 min-w-90">
                      <span class="fs-16">{{ link.title }}</span>
                    </button>
                  </div>
                  <div style="float: right; color: #e02020"
                       *ngIf="
                      link.title === 'Data Health Status' &&
                      showDataHealth &&
                      etlNotificationSettings().spendETLEnabled &&
                      etlNotificationSettings().etlStatus === 1
                    ">
                    <span style="font-size: 26px"><i class="fas fa-exclamation-square"></i></span>
                  </div>
                  <div style="float: right; color: #f29100"
                       *ngIf="
                      link.title === 'Data Health Status' &&
                      showDataHealth &&
                      etlNotificationSettings().spendETLEnabled &&
                      etlNotificationSettings().etlStatus === 2
                    ">
                    <span style="font-size: 26px"><i class="fas fa-exclamation-triangle"></i></span>
                  </div>
                </div>
              </ng-container>
            </div>
          </mat-menu>
        </div>
        <div class="sidebar-item sidebar-item-toggle force-top-separator" [class.force-top-separator]="!supportLinks?.length" #sidebarItem>
          <a class="sidebar-item__button"
             [routerLink]=""
             [matMenuTriggerFor]="profileMenu"
             #menuTrigger="matMenuTrigger"
             (menuOpened)="profileMenuOpened = menuTrigger.menuOpen"
             (menuClosed)="profileMenuOpened = menuTrigger.menuOpen"
             [class.active]="profileMenuOpened">
            <div class="sidebar-item__icon">
              <i class="far fa-user-circle"></i>
            </div>
            <span class="sidebar-item__text">Profile</span>
          </a>
          <mat-menu #profileMenu class="sidebar-item-toggle__content sidebar-item-toggle__profile" xPosition="after" [hasBackdrop]="true">
            <div class="bgc-blue c-white d-flex align-items-center justify-content-between h-40 px-15 br-t4">
              <div>
                <i class="fal fa-user-circle mr-8"></i>
                <span class="fs-18">Profile</span>
              </div>
              <div>
                <a class="pointer" [routerLink]="" (click)="manageProfile(0)">
                  <span class="fs-14 mr-4 underline">Manage</span>
                  <i class="fal fa-user-cog"></i>
                </a>
              </div>
            </div>
            <div class="px-15 py-12 br-b4">
              <div class="border-b-solid-1 bc-grey-5 pb-12">
                <div class="d-block fs-16 bold c-dark-blue-2 mb-8">
                  <span class="text-ellipsis" [title]="userName">{{ userName }}</span>
                </div>
                <div class="d-block fs-14 c-grey-16">
                  <span class="text-ellipsis" [title]="email">{{ email }}</span>
                </div>
                <div class="d-block fs-16 c-grey-5 mb-5 mt-14">
                  <div *ngIf="features?.general?.organisationSelect && organisations.length > 1; else normalUser" class="d-flex align-items-center">
                    <mat-select class="trg-outline w-100p"
                                panelClass="trg-outline-dropdown fs-14"
                                [ngModel]="organisationId"
                                (ngModelChange)="setSelectedOrganisation($event)"
                                click-stop-propagation>
                      <mat-option *ngIf="organisations.length > 4">
                        <ngx-mat-select-search [formControl]="organisationFilterCtrl"
                                               placeholderLabel="Enter Search"
                                               noEntriesFoundLabel="No matches found"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let organisation of organisations" [value]="organisation.id" [hidden]="organisation.hidden">
                        {{ organisation.name }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <ng-template #normalUser>
                    <span class="text-ellipsis" [title]="user.organisationDisplayName">{{ user.organisationDisplayName }}</span>
                  </ng-template>
                </div>
                <div class="d-block fs-16 c-grey-5 mb-5 mt-14">
                  <div *ngIf="isImpersonating || (features?.general?.userImpersonation && impersonationableUsers.length > 0)" class="d-flex align-items-center">
                    <mat-select *ngIf="!isImpersonating"
                                class="trg-outline w-100p"
                                panelClass="trg-outline-dropdown fs-14"
                                [ngModel]="impersonatedUserId"
                                (ngModelChange)="setImpersonatedUser($event)"
                                [disabled]="loadingImpersonationableUsers"
                                placeholder="Impersonate user..."
                                click-stop-propagation>
                      <mat-option *ngIf="impersonationableUsers.length > 4">
                        <ngx-mat-select-search [formControl]="impersonationableUsersFilterCtrl"
                                               placeholderLabel="Enter Search"
                                               noEntriesFoundLabel="No matches found"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let u of impersonationableUsers" [value]="u.id" [hidden]="u.hidden">
                        {{ u.username }}
                      </mat-option>
                    </mat-select>
                    <span *ngIf="isImpersonating" class="text-ellipsis" [title]="impersonatedUser.name">
                      Impersonating
                      <br />
                      <strong>{{ impersonatedUser.name }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="pt-15 sidebar-profile-menu__buttons">
                <a *ngIf="!businessUser" class="" [href]="changePasswordUrl" target="_blank">
                  <span>Change Password</span>
                  <i class="fal fa-pencil-alt"></i>
                </a>
                <a class="" routerLink="/logout">
                  <span>Logout</span>
                  <i class="far fa-sign-out"></i>
                </a>
              </div>
              <div class="c-blue mt-10">
                <a class="fs-12 underline" href="https://www.trgscreen.com/privacy-policy">Privacy Policy</a>
                <div class="dot-2 bgc-blue mx-6"></div>
                <a class="fs-12 underline" href="https://www.trgscreen.com/privacy-policy">Terms &amp; Conditions</a>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>

  <div class="main-container">
    <div class="main-content">
      <ng-content></ng-content>
    </div>
  </div>

  <ng-container *ngIf="activeOrganisationIsDifferent || isImpersonating">
    <div class="user-overrides-overlay">
      <span *ngIf="activeOrganisationIsDifferent && !isImpersonating">
        {{ activeOrganisationName }}
      </span>
      <span *ngIf="isImpersonating">
        Impersonating
        <strong>{{ impersonatedUser.name }}</strong>
      </span>
    </div>
    <button type="button"
            trgButton
            color="outline"
            class="user-overrides-overlay-btn"
            (click)="isImpersonating ? setImpersonatedUser(null) : setSelectedOrganisation(null)">
      <span>{{ isImpersonating ? "Cancel" : "Reset" }}</span>
    </button>
  </ng-container>
</div>

<div *ngIf="showSessionInfo()" class="session-state fs-12 c-grey-16" [class.hide-session-info]="hideSessionInfo()">
  <span [hidden]="!hideSessionInfo()">Session</span>
  <span class="hide-btn">
    <i class="fas {{ hideSessionInfo() ? 'fa-eye-slash' : 'fa-eye' }} pointer icon-btn hide-btn" 
       (click)="toggleHideSessionInfo()"></i>
  </span>
  <div class="d-flex align-items-center">
    <div class="d-flex flex-dir-column bold text-right">
      <span>Expiry time:</span>
      <span class="mt-4">Expiry in:</span>
      <span class="mt-4">Prompt in:</span>
      <span class="mt-4">Is Idle:</span>
      <span class="mt-4">Deidle Checks:</span>
    </div>
    <div class="d-flex flex-dir-column ml-8" style="width: 100px">
      <span>{{ sessionExpiresOn() }}</span>
      <span class="mt-4">{{ sessionExpiresIn() }}</span>
      <span class="mt-4">{{ expiryPromptIn() }}</span>
      <span class="mt-4">
        <i class="mr-4 fas {{ authService.isIdle ? 'fa-check' : 'fa-times' }} pointer icon-btn" (click)="toggleIdle()"></i>
        (in {{ idleIn() }})
      </span>
      <span class="mt-4">
        <i class="mr-4 fas {{ authService.pauseDeidle ? 'fa-times' : 'fa-check' }} pointer icon-btn" (click)="toggleDeidle()"></i>
        ({{ authService.pauseDeidle ? "paused" : "active" }})
      </span>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-between mt-4" style="font-size: 10px !important">
    <div>
      <span>15 min</span>
      <i class="fas fa-plus-circle pointer icon-btn ml-4" (click)="addToSessionExpiry(15 * (60 * 1000))"></i>
      <i class="fas fa-minus-circle pointer icon-btn ml-4" (click)="addToSessionExpiry(-15 * (60 * 1000))"></i>
    </div>
    <div class="vl"></div>
    <div>
      <span>5 min</span>
      <i class="fas fa-plus-circle pointer icon-btn ml-4" (click)="addToSessionExpiry(5 * (60 * 1000))"></i>
      <i class="fas fa-minus-circle pointer icon-btn ml-4" (click)="addToSessionExpiry(-5 * (60 * 1000))"></i>
    </div>
    <div class="vl"></div>
    <div>
      <span>1 min</span>
      <i class="fas fa-plus-circle pointer icon-btn ml-4" (click)="addToSessionExpiry(1 * (60 * 1000))"></i>
      <i class="fas fa-minus-circle pointer icon-btn ml-4" (click)="addToSessionExpiry(-1 * (60 * 1000))"></i>
    </div>
  </div>
</div>

@if (showLoggerConfig()) {
  <div class="logger-config" [class.logger-config-hidden]="!loggerConfigToggle()">
    <div class="d-flex align-items-center justify-content-between w-100p">
      <span class="fs-14 bold">
        Logger
      </span>
      <span class="hide-btn" (click)="loggerConfigToggle.set(!loggerConfigToggle())">
        <i class="fas {{ hideSessionInfo() ? 'fa-eye-slash' : 'fa-eye' }} pointer icon-btn hide-btn"></i>
      </span>
    </div>
    <span class="fs-12 mt-4 logger-subtitle">Levels</span>
    <div class="logger-config-levels">
      @for (l of logLevels(); track l) {
        <div>
          <div>{{l.name}}</div>
          <div>
            <trg-checkbox appearance="square" [value]="l.enabled()" (valueChange)="l.setEnabled($event)"></trg-checkbox>
          </div>
        </div>
      }
    </div>
    <span class="fs-12 mt-4 logger-subtitle">Categories</span>
    <div class="logger-config-categories">
      @for (c of logCategories(); track c) {
        <div>
          <div>{{c.name}}</div>
          <div>
            <trg-checkbox appearance="square" [value]="c.enabled()" (valueChange)="c.setEnabled($event)"></trg-checkbox>
          </div>
        </div>
      }
    </div>
  </div>
}

<div class="insights-profile-changed-overlay"></div>

<ng-template #sidebarMenuLink let-icon="icon" let-title="title" let-url="url">
  <a class="sidebar-item__button"
     [routerLink]="url"
     routerLinkActive
     #rla="routerLinkActive"
     [class.active]="rla.isActive && !insightsLibraryVisible">
    <div class="sidebar-item__icon">
      <i class="{{ icon }}"></i>
    </div>
    <span class="sidebar-item__text">{{ title }}</span>
  </a>
</ng-template>
